import { Flex, Input, Select, Tabs } from "antd";
import { TabsProps } from "antd/lib";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDebounce } from "use-debounce";
import { useIzvestajiOPrometu } from "../../modules/trackAndTrace/trackAndTrace.queries";
import { IzvestajiOPrometuTab } from "../../modules/trackAndTrace/trackAndTrace.types";
import { PaginationPayload } from "../../types";
import style from "./IzvestajiOPrometuPage.module.scss";
import ProizvodnjaTable from "./ProizvodnjaTable/ProizvodnjaTable";
import UvozTable from "./UvozTable/UvozTable";
import VeletrgovinaTable from "./VeletrgovinaTable/VeletrgovinaTable";

const IzvestajiOPrometuPage = () => {
  const { t } = useTranslation();
  const [selectedTab, setSelectedTab] = useState<IzvestajiOPrometuTab>(
    IzvestajiOPrometuTab.PROIZVODNJA
  );
  const [pib, setPib] = useState<string | null>(null);
  const [pibMaloprodaje, setPibMaloprodaje] = useState<string | null>(null);
  const [periodId, setPeriodId] = useState<number | null>(null);
  const [pagination, setPagination] = useState<PaginationPayload>({
    pageNumber: 1,
    pageSize: 10,
  });

  const debouncedPib = useDebounce(pib, 500);
  const debouncedPibMaloprodaje = useDebounce(pibMaloprodaje, 500);

  const { data: izvestajiOPrometu } = useIzvestajiOPrometu({
    filters: {
      periodId,
      pib: debouncedPib[0],
      pibMaloprodaje: debouncedPibMaloprodaje[0],
      pageNumber: pagination.pageNumber,
      pageSize: pagination.pageSize,
    },
  });

  const tabs: TabsProps["items"] = [
    {
      key: IzvestajiOPrometuTab.PROIZVODNJA,
      label: t("TRACK.PROIZVODNJA"),
      children: (
        <ProizvodnjaTable proizvodnja={izvestajiOPrometu?.proizvodnja ?? []} />
      ),
    },
    {
      key: IzvestajiOPrometuTab.UVOZ,
      label: t("TRACK.UVOZ"),
      children: <UvozTable uvoz={izvestajiOPrometu?.uvoz ?? []} />,
    },
    {
      key: IzvestajiOPrometuTab.VELETRGOVINA,
      label: t("TRACK.VELETRGOVINA"),
      children: (
        <VeletrgovinaTable
          veletrgovina={izvestajiOPrometu?.veletrgovina ?? []}
          pagination={pagination}
          setPagination={(pagination) => {
            setPagination(pagination);
          }}
          totalCount={izvestajiOPrometu?.totalCount ?? 0}
        />
      ),
    },
  ];

  const setTabHandler = (tabKey: string) => {
    setSelectedTab(tabKey as IzvestajiOPrometuTab);
  };

  const onPeriodChangeHandler = (value: number | null) => {
    setPeriodId(value);
  };

  useEffect(() => {
    if (
      izvestajiOPrometu?.periodId !== periodId &&
      izvestajiOPrometu?.periodId &&
      periodId === null
    ) {
      setPeriodId(izvestajiOPrometu?.periodId);
    }
  }, [izvestajiOPrometu?.periodId, periodId]);

  useEffect(() => {
    if (
      selectedTab !== IzvestajiOPrometuTab.VELETRGOVINA &&
      pibMaloprodaje !== null
    ) {
      setPibMaloprodaje(null);
    }
  }, [selectedTab]);

  return (
    <div className={style.mainContainer}>
      <div id="periodic">
        <h2>{t("TRACK.IZVESTAJI_O_PROMETU")}</h2>
        <Flex
          gap={16}
          align="center"
          style={{ paddingBottom: 10, width: "60%" }}
          id="izvestaji-o-prometu-filters"
        >
          <Select
            value={periodId}
            onChange={onPeriodChangeHandler}
            options={izvestajiOPrometu?.period?.map((period) => ({
              label: period.naziv,
              value: period.id,
            }))}
            placeholder={t("AKCIZNE_MARKICE.PERIOD")}
          />
          <Input
            allowClear
            onChange={(event) => setPib(event.target.value)}
            placeholder={t("PLACEHOLDERS.PIB")}
            name="pib-izvestaji-o-prometu"
            value={pib ?? ""}
          />
          {selectedTab === IzvestajiOPrometuTab.VELETRGOVINA ? (
            <Input
              allowClear
              onChange={(event) => setPibMaloprodaje(event.target.value)}
              placeholder={t("PLACEHOLDERS.PIB_MALOPRODAJE")}
              name="pib-maloprodaje-izvestaji-o-prometu"
              value={pibMaloprodaje ?? ""}
            />
          ) : null}
        </Flex>
      </div>
      <Tabs
        items={tabs}
        activeKey={selectedTab}
        onChange={setTabHandler}
        destroyInactiveTabPane
      />
    </div>
  );
};

export default IzvestajiOPrometuPage;
